export default __webpack_public_path__ + "static/media/ProfileLight.83bfb0d8.svg";